import clsx from "clsx";
import { formModes } from "EmbeddedForm.hook";
import { ReactComponent as HipaaLogo } from "images/hipaa-logo.svg";
import { ReactComponent as PoweredByRsLogo } from "images/powered-by-rs.svg";

export const IframeContent = ({ formCode }) => {
  const buttonClass = clsx(
    "bg-[#225DA4] text-white font-bold",
    "py-4 px-8 text-[24px] rounded-xl",
    "xs:py-3 xs:px-8 xs:text-[29px]",
    "sm:py-4 sm:px-8 sm:text-[34px] sm:rounded-2xl ",
    "md:py-6 md:px-12 md:text-[38px] md:rounded-3xl ",
    "lg:py-9 lg:px-16 lg:text-[44px]",
    "hover:bg-[#124D94] inline-block text-center tracking-tight",
    "m-0"
  );

  const outlinedButtonClass = clsx(
    "border-4 border-[#225DA4] text-black font-bold",
    "px-6 py-2 text-[17px] rounded-xl",
    "xs:px-6 xs:py-1.5 xs:text-[22px] ",
    "sm:px-6 sm:py-3 sm:text-[24px] sm:rounded-2xl",
    "md:px-8 md:py-4 md:text-[30px] ",
    "lg:px-11 lg:py-6 lg:text-[34px]",
    "hover:bg-blue-50 inline-block text-center",
    "m-0"
  );

  return (
    <div
      className={clsx(
        "flex rounded-3xl",
        "flex-col justify-start items-stretch",
        "border-solid border-2 border-gray-400 overflow-hidden",
        "min-h-full h-screen overflow-hidden bg-white"
      )}
    >
      <div className="flex-1 w-full flex flex-0 flex-col justify-between items-center">
        <HipaaLogo className="ml-3 sm:ml-4 mt-0.5 xs:mt-1 sm:mt-2 place-self-start w-[75px] xs:w-[100px] sm:w-[132px]" />
        <div
          className={clsx(
            "flex flex-col items-center justify-center gap-0.5",
            "sm:flex-row sm:flex-wrap sm:items-center sm:gap-8"
          )}
        >
          <a
            href={`/embedded_form/${formCode}/${formModes.CREATE_REFERRAL}`}
            target="_blank"
            rel="noopener noreferrer"
            className={buttonClass}
          >
            Send a Referral
          </a>
          <div className="text-[#71839B] text-[16px] xs:text-[22px] font-bold sm:hidden">
            <i>or</i>
          </div>
          <a
            href={`/embedded_form/${formCode}/${formModes.ASK_QUESTION}`}
            target="_blank"
            rel="noopener noreferrer"
            className={outlinedButtonClass}
          >
            Message Us
          </a>
        </div>
        <PoweredByRsLogo className="place-self-end mr-3 sm:mr-4 mb-0.5 xs:mb-1 sm:mb-2 w-[53px] xs:w-[70px] sm:w-[80px] md:w-[90px]" />
      </div>
    </div>
  );
};
